<template>
	<transition name="slide">
		<ul class="itemlist">

			<slot></slot>
		</ul>
	</transition>
</template>
<script>
	export default {
		name: 'itemlist',
	}
</script>



<style lang="scss">
	@import '../../../docs/scss/variables';
	.slide-enter-active, .slide-leave-active {
		transition: all 1s;
	}
	.slide-enter, .slide-leave-to {
		transform: translateY(-5%);
		opacity: 0;
	}

</style>



// WEBPACK FOOTER //
// src/components/itemlist/itemlist.vue